import LoadingSkeleton from "@/components/loadingSkeleton/LoadingSkeleton";

import styles from "./RankCardWidget.module.scss";

const RankCardSkeleton = () => (
  <div className={styles.wrapper}>
    <LoadingSkeleton height="48px" minHeight="48px" containerClassName={styles.skeleton} />
  </div>
);

export default RankCardSkeleton;
